import { apiUrl } from '../../config/net'
const index = `${apiUrl}/v0/onlinemall/mobile/material/index`
const couponInfo = `${apiUrl}/v0/ordercoupon/getmcouponinfo`
const banners = `${apiUrl}/v0/wumao/MobileMallMaterialIndex`
const detail = `${apiUrl}/v0/onlinemall/mobile/material/info/`

export default {
  index,
  couponInfo,
  banners,
  detail
}



// WEBPACK FOOTER //
// ./src/model/hardware-market/resource-url.js